import {DEFAULT_BOUNDS, emptyHistogram, sameHistogramBounds} from '@/utils/histogram-utils';

export default {
  state() {
    return {
      violetColormap: true,
      bounds: DEFAULT_BOUNDS,

      ongoingHistogramExtraction: false,
      histogram: emptyHistogram(),
      pixelCount: 0,
    }
  },

  mutations: {
    setVioletColormap(state, on) {
      state.violetColormap = on;
    },
    toggleVioletColormap(state) {
      state.violetColormap = !state.violetColormap;
    },
    setBounds(state, bounds) {
      state.bounds = bounds;
    },

    setOngoingHistogramExtraction(state, ongoing) {
      state.ongoingHistogramExtraction = ongoing;
    },
    setHistogram(state, histogram) {
      state.histogram = histogram;
    },
    setPixelCount(state, count) {
      state.pixelCount = count;
    }
  },

  actions: {
    setImageInstance({commit}) {
      commit('setHistogram', emptyHistogram());
      commit('setPixelCount', 0);
      commit('setOngoingHistogramExtraction', false);
    },

    startHistogramExtraction({commit}) {
      commit('setHistogram', emptyHistogram());
      commit('setPixelCount', 0);
      commit('setOngoingHistogramExtraction', true);
    },
    endHistogramExtraction({commit}, {histogram, pixelCount = undefined}) {
      commit('setHistogram', histogram);
      commit('setPixelCount', pixelCount || histogram.reduce((acc, n) => acc + n, 0));
      commit('setOngoingHistogramExtraction', false);
    }
  },
}
